import { render, staticRenderFns } from "./FormPricingSend.vue?vue&type=template&id=f5ba141e&"
import script from "./FormPricingSend.vue?vue&type=script&lang=js&"
export * from "./FormPricingSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports